import ClientStore from './ClientStore';

class LocalStore extends ClientStore {
  constructor() {
    super(localStorage, {});
  }

  getAll(namespace: string) {
    return this.get(namespace);
  }

  getConfig(key: string) {
    const config = this.get('Config');
    return config[key];
  }

  setConfig(key: string, value: any) {
    const config = this.get('Config');
    config[key] = value;
    this.set('Config', config);
  }

  removeObject(namespace: string, key: string) {
    const obj = this.getAll(namespace);
    delete obj[key];
    this.set(namespace, obj);
  }

  getObject(namespace: string, key: string) {
    return this.getAll(namespace)[key];
  }

  setObject(namespace: string, key: string, value: any) {
    if (value) {
      const obj = this.getAll(namespace);
      obj[key] = value;
      this.set(namespace, obj);
    } else {
      this.removeObject(namespace, key);
    }
  }

  getObjectForChat(partnerId: string, chatId: string, key: string) {
    const chats = this.getObject(partnerId, 'chatHistory') || [];
    const chat = chats.find((c: { chatId: string }) => c.chatId === chatId);
    return chat && chat[key];
  }

  pushObjectForChat(partnerId: string, chatId: string, values: any) {
    const partner = this.getAll(partnerId);
    const chats = partner.chatHistory || [];
    const chat = chats.find((c: { chatId: string}) => c.chatId === chatId);
    if (!chat) {
      chats.push(values);
    } else {
      Object.assign(chat, values);
    }
    partner.chatHistory = chats;
    this.set(partnerId, partner);
  }
}

export default new LocalStore();
